import {useEffect} from "react";
import { useCallback } from "react";
import {useSignal, useComputed} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { DISPLAY_TABS } from "../@constants";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import {elementsInLoading} from "../../../@signals";


export default function usePriceDiscountTopMarketChanges() {
	const { urlApi } = usePricingDiscountRoleConfig()

	const isLoadingStock = useSignal(false)
	const dataStock = useSignal({})
	const countriesStock = useSignal([])
	const selectedCountryPrice = useSignal(null)

	const isLoadingPrice = useSignal(false)
	const dataPrice = useSignal({})
	const countriesPrice = useSignal([])
	const selectedCountryStock = useSignal(null)

	const displayTable = useSignal(DISPLAY_TABS.PRICE_CHANGES)

	const currentPriceData = useComputed(() => dataPrice.value[selectedCountryPrice.value])
	const currentStockData = useComputed(() => dataStock.value[selectedCountryStock.value])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoadingStock.value = true
			isLoadingPrice.value = true
			dataPrice.value = []
			postSubmit(`${urlApi}/top-price-changes`, { ...commonFiltersValue.value }).then(res => {
				dataPrice.value = res.countriesData
				countriesPrice.value = res.countries
				selectedCountryPrice.value = res.countries[0]
			})
			.catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => isLoadingPrice.value = false)
			
			postSubmit(`${urlApi}/top-stock-changes`, { ...commonFiltersValue.value }).then(res => {
				dataStock.value = res.countriesData
				countriesStock.value = res.countries
				selectedCountryStock.value = res.countries[0]
			})
			.catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => isLoadingStock.value = false)
		}
	}, [isLoadingCommonFilters.value]);

	const handleChangeTabs = (_, newValue) => {
		displayTable.value = newValue
	}

	const handleSelectedCountryPrice = useCallback(newValue => {
		selectedCountryPrice.value = newValue
	}, [])

	const handleSelectedCountryStock = useCallback(newValue => {
		selectedCountryStock.value = newValue
	}, [])

	useEffect(() => {
		if (isLoadingStock.value && isLoadingPrice.value)
			elementsInLoading.value = [...elementsInLoading.value, 'topMarketChanges']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'topMarketChanges')
	}, [isLoadingStock.value, isLoadingPrice.value])

	return {
		isLoadingStock: isLoadingStock.value,
		isLoadingPrice: isLoadingPrice.value,
		dataPrice: currentPriceData.value,
		displayTable: displayTable.value,
		dataStock: currentStockData.value,
		countriesPrice: countriesPrice.value,
		countriesStock: countriesStock.value,
		selectedCountryPrice: selectedCountryPrice.value,
		selectedCountryStock: selectedCountryStock.value,
		handleChangeTabs,
		handleSelectedCountryPrice,
		handleSelectedCountryStock,
	}
}